import { AbstractPaintableItem } from "./AbstractPaintableItem";
import { TypeKeys } from "./TypeKeys";

export class CircleItem extends AbstractPaintableItem {
  constructor() {
    super(TypeKeys.CircleItem);
  }
 
  protected createCloneInstance(): CircleItem {
    return new CircleItem();
  }
}
